<template>
  <div>

    <p>

    <h2> 同步数据syncData ,以后同步数据相关的都放这里 点击后 显示同步结果! </h2>
    </p>

    <el-button type="primary" @click="getData">同步所有数据=>已经修改到更新所有数据</el-button>
    <br> <br>

    <el-button type="primary" @click="syncCoachCourse">更新教练和课程信息</el-button>
    <br> <br>

    <el-button type="primary" @click="updateActiveReport">更新一波活跃报告数据</el-button>
    <br> <br>

    <el-button type="primary" @click="updateActiveDistribution">更新一波活跃行为分布</el-button>
    <br> <br>


    <el-divider></el-divider>
    <h4 style="text-align: left;"> 从 Stripe 后台 同步数据 Invoice </h4>
    <el-button type="primary" style="  background-color: red; border-color: red; color: white;  "
      @click="getAllInvoice">全量更新 Invoice List === 不点了 !!! </el-button>

    <el-button type="primary" @click="getNewInvoice">增量更新 Invoice List 并写入数据库 </el-button>

    <el-button type="primary" @click="updateInvoice">更新最近一段时间的Invoice状态 </el-button>
    <el-divider></el-divider>
    <h4 style="text-align: left;"> 从 分析 subs 别 retention </h4>

    <el-button type="primary" @click="getAllSubs">全量更新 Subscription 并写入数据库 </el-button>
    <el-button type="primary" @click="syncSubsRetention">分析 subs 别 retention </el-button>

    <el-button type="primary" @click="syncSubsTrailInfo">更新账号别试用情况 </el-button>

    <br> <br> <br>

    <div>{{ responseData }}</div>
  </div>

</template>




<script>


export default {
  data() {
    return {
      responseData: '',

    };
  },
  methods: {
    getData() {
      this.$http.get('/da/sync_data')
        .then(response => {
          // 这里需要处理把 Response 显示到上面的div中
          this.responseData = response.data;
          // this.buttonText = '再次获取数据';
        })
        .catch(error => {
          console.error(error);
        });
    },

    //更新教练课程数据
    syncCoachCourse() {
      this.$http.get('/da/sync_coach_course')
        .then(response => {
          // 这里需要处理把 Response 显示到上面的div中
          this.responseData = response.data;
          // this.buttonText = '再次获取数据';
        })
        .catch(error => {
          console.error(error);
        });
    },


    //更新一波活跃报告数据
    updateActiveReport() {
      this.$http.get('/da/update_active_report')
        .then(response => {
          // 这里需要处理把 Response 显示到上面的div中
          this.responseData = response.data;
          // this.buttonText = '再次获取数据';
        })
        .catch(error => {
          console.error(error);
        });
    },

    ///////updateActiveDistribution">更新一波活跃行为分布
    updateActiveDistribution() {
      this.responseData = "下面开始分析活跃分布数据"
      this.$http.get('/da/update_active_distribution')
        .then(response => {
          // 这里需要处理把 Response 显示到上面的div中
          this.responseData = "活跃分布数据分析完成" + response.data;
          // this.buttonText = '再次获取数据';
        })
        .catch(error => {
          console.error(error);
        });
    },

    ///////updateActiveDistributionApp">更新一波 App端 活跃行为分布
    updateActiveDistributionApp() {
      this.responseData = "下面开始分析 App端 活跃分布数据"
      this.$http.get('/da/update_active_distribution_app')
        .then(response => {
          // 这里需要处理把 Response 显示到上面的div中
          this.responseData = " App端 活跃分布数据分析完成" + response.data;
          // this.buttonText = '再次获取数据';
        })
        .catch(error => {
          console.error(error);
        });
    },

    getAllInvoice() {
      this.$http.get('/da/get_stripe_invoice')
        .then(response => {
          this.responseData = response.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    getNewInvoice() {
      this.$http.get('/da/get_new_stripe_invoice')
        .then(response => {
          this.responseData = response.data;
        })
        .catch(error => {
          console.error(error);
        });
    },

    //   @click="updateInvoice"
    //  更新最近一段时间的Invoice状态  '/da/update_recent_invoice'
    updateInvoice() {
      this.$http.get('/da/update_recent_invoice')
        .then(response => {
          // 这里需要处理把 Response 显示到上面的div中
          this.responseData = response.data;
          // this.buttonText = '再次获取数据';
        })
        .catch(error => {
          console.error(error);
        });
    },


    getAllSubs() {
      this.$http.get('/da/get_stripe_subs')
        .then(response => {
          // 这里需要处理把 Response 显示到上面的div中
          this.responseData = response.data;
          // this.buttonText = '再次获取数据';
        })
        .catch(error => {
          console.error(error);
        });
    },




    //  syncSubsRetention">分析 subs 别 retention
    syncSubsRetention() {
      this.responseData = "下面开始分析  subs 别 retention"
      this.$http.get('/da/sync_subs_retention')
        .then(response => {
          // 这里需要处理把 Response 显示到上面的div中
          this.responseData = "  subs 别 retention 分析完成" + response.data;
          // this.buttonText = '再次获取数据';
        })
        .catch(error => {
          console.error(error);
        });
    },

    //  "  @click="syncSubsTrailInfo">
    //  更新账号别试用情况
    syncSubsTrailInfo() {
      this.responseData = "下面开始分析  subs 别 Trail Info"
      this.$http.get('/da/sync_subs_trial')
        .then(response => {
          // 这里需要处理把 Response 显示到上面的div中
          this.responseData = "  subs 别  Trail Info 分析完成" + response.data;
          // this.buttonText = '再次获取数据';
        })
        .catch(error => {
          console.error(error);
        });
    },
  }
};
</script>